<template>
    <!-- <div class="jr-component" :style="'height: ' + tableHeight + 'px; width: ' + tableWidthAll + 'px; position:relative;'"> -->
      <div class="jr-component" :style="'height: 100%; width: ' + tableWidthAll + 'px; position:relative;'">
        <!-- {{datas}}s -->
        <!-- {{selected}} -->
          <pl-table v-bind="$attrs" :id="components.tableId" 
                    @header-dragend="headerDragend"
                    @cell-click="cellClick"
                    @sort-change="sortChange"
                    @selection-change="selectionChange"
                    :data="datas"
                    :ref="components.tableId"
                    :big-data-checkbox="true"
                    :fixed-columns-roll="true"
                    :size="size"
                    :show-summary="showSummary"
                    :use-virtual="true"
                    :cell-class-name="cellClass"
                    :row-class-name="rowClass" 
                    :height="tableHeight"                   
                    :total-option="components.tableSumOptions"                    
                    

                    :pagination-show="false"
                    :current-page="queryLimit.offset+1"
                    :page-size="components.tablePagesize"
                    :row-height="30">
            <template slot="empty">没有符合条件的记录</template>            
            <pl-table-column :key="0" v-if="selection" type="selection" width="50"/>
            <pl-table-column :key="1" v-if="index" type="index" width="50" :show-overflow-tooltip="true"/>
            <template v-for="(item, i) in components.tableColumns">
              <pl-table-column v-if="item.columnType != 'Date' && item.columnType != 'Datetime' && item.columnType != 'Select' && item.columnVisible"
              :key="i+2"
              :sortable="true"
              :show-overflow-tooltip="true"
              :resizable="true"
              :prop="item.columnName"
              :label="item.columnDisplayname"
              :width="item.columnWidth">      
                <template slot-scope="scope" >
                  <template v-if="!item.columnReadonly && nowRows == scope.$index && !readOnly">
                    <!-- <jr-inputtable v-model="datas[scope.$index][item.columnName]" placeholder="请输入内容"></jr-inputtable> -->
                    <el-input v-model="scope.row[item.columnName]" size="mini" placeholder="请输入内容"></el-input>
                  </template>                  
                  <!-- <template v-else>{{datas[scope.$index][item.columnName]}}</template> -->
                  <template v-else>{{scope.row[item.columnName]}}</template>
                </template>        
              </pl-table-column>  
              <pl-table-column v-if="item.columnType == 'Select' && item.columnVisible"
              :key="i+2"
              :sortable="true"
              :show-overflow-tooltip="true"
              :resizable="true"
              :prop="item.columnName"
              :label="item.columnDisplayname"
              :width="item.columnWidth">      
                <template slot-scope="scope">
                  <!-- existsType类型 -->
                  <template v-if="item.columnDatasource == 'existsType'">
                    <template v-if="!item.columnReadonly && nowRows == scope.$index && !readOnly">
                      <el-select v-model="scope.row[item.columnName]" size="mini" placeholder="请选择">
                        <el-option v-for="(item, i) in existsType" :key="item" :label="item" :value="i"/>
                      </el-select>
                    </template>                  
                    <template v-else>{{existsType[scope.row[item.columnName]]}}</template>
                  </template>                  
                </template>        
              </pl-table-column> 
              <pl-table-column v-if="item.columnType == 'Date' && item.columnVisible"
              :key="i+2"
              :sortable="true"
              :show-overflow-tooltip="true"
              :resizable="true"
              :prop="item.columnName"
              :label="item.columnDisplayname"
              :width="item.columnWidth">      
                <template slot-scope="scope">
                  <template v-if="!item.columnReadonly && nowRows == scope.$index && !readOnly">
                    <el-date-picker :style="'width: ' + (item.columnWidth-22) + 'px;'"
                      :editable="false"
                      size="mini" 
                      v-model="scope.row[item.columnName]" 
                      type="date" 
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="日期时间">
                    </el-date-picker>
                  </template>                  
                  <template v-else>{{scope.row[item.columnName]==null ? "":(scope.row[item.columnName]+"").substring(0,10)}}</template>
                </template>    
              </pl-table-column> 
              <pl-table-column v-if="item.columnType == 'Datetime' && item.columnVisible"
              :key="i+2"
              :sortable="true"
              :show-overflow-tooltip="true"
              :resizable="true"
              :prop="item.columnName"
              :label="item.columnDisplayname"
              :width="item.columnWidth">
                <template slot-scope="scope">
                  <template v-if="!item.columnReadonly && nowRows == scope.$index">
                    <el-date-picker  :style="'width: ' + (item.columnWidth-22) + 'px;'"
                      :editable="false"
                      size="mini" 
                      v-model="scope.row[item.columnName]" 
                      type="datetime" 
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="日期">
                    </el-date-picker>
                  </template>                  
                  <template v-else>{{scope.row[item.columnName]}}</template>
                </template>        
              </pl-table-column>
            </template>
          </pl-table>
          <el-row align="middle" justify="center" class="jr-bigtable-badge">
            <el-button @click="exportExcel(true)" size="mini" type="primary" icon="el-icon-download" title="导出全部">导出全部</el-button>
            <el-button @click="bigtableVisible = true" size="mini" type="success" icon="el-icon-setting" circle title="表格设置"></el-button>
          </el-row>
          <el-dialog title="表格参数配置" :visible.sync="bigtableVisible" :close-on-click-modal="false" width="500px">
            <div style="height: 400px; overflow-y: scroll;">
              <div style="width: 95%; display: flex; flex-direction: row ; align-items: center;">
                <b style="width: 200px; text-align: left;">列名</b> 
                <b style="width: 120px; text-align: left;">是否可见</b>
                <b style="width: 120px; text-align: left;">列宽</b>
                <b style="width: 40px; text-align: left;">顺序</b>
              </div>
              <hr>
              <transition-group tag="div" class="container">
                <div class="jr-bigtable-column-item" v-for="(item, i) in components.tableColumns" v-bind:key="item.columnId"  :draggable="draggable" 
                @dragstart="handleDragStart($event, item)"
                @dragover.prevent="handleDragOver($event, item)"  
                @dragend="handleDragEnd($event, item)" 
                @dragenter="handleDragEnter($event, item)">
                  <p style="width: 150px;">{{item.columnDisplayname + '：'}}</p> 
                  <el-checkbox v-model="item.columnVisible" style="text-align: left;">是否可见</el-checkbox>
                  <el-input style="width: 80px;" v-model="item.columnWidth" placeholder="宽度" :minlength="50" :maxlength="500" size="small" ></el-input>
                  <i @mousedown="draggable = true" @mouseleave="draggable = false" class="el-icon-s-operation jr-bigtable-setting-move"></i>
                </div>
              </transition-group>
            </div>
            <span slot="footer" class="dialog-footer">
              <div style="width: 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
                <el-button @click="rollBackTableSetting" :loading="queryLoding" type="warning">还原默认值</el-button>
                <div>
                  <el-button @click="bigtableVisible = false">取 消</el-button>
                  <el-button type="primary" :loading="saveLoding" @click="saveTableSetting">保 存</el-button>
                </div>
              </div>
            </span>
          </el-dialog>
    </div>
</template>
<script>
import store from '@/store'
import JRGLOBAL from '@/api/jrglobal'
import { rollBackTableSetting, saveTableSetting, queryExport, downLoadExcel, queryItemExport} from '@/api/public'
import { Notification } from "element-ui"
export default {
  name: 'JrBigtable',
  data() {
    return {
      // 性别
      sex: JRGLOBAL.sex,
      // 是否
      yesOrno: JRGLOBAL.yesOrno,
      // 是否有效
      existsType: JRGLOBAL.existsType,
      bigtableVisible: false,
      columnDataProps: {},
      tableHeight: 700,
      tableWidth: 1424,
      draggable: false,
      queryLoding: false,
      saveLoding: false,
      datas: [],
      nowRows: -1
    }
  },
  watch: {
    tableItemData :{
      handler(newName, oldName) {
        this.datas = newName    
      },
      deep: true,
      immediate: true
    },
    
  },
  computed: {
    columnDataProp() {
      let columnDataProp = {}
      this.components.tableColumns.forEach(item=>{       
        columnDataProp[item.columnName] = item
      })
      return columnDataProp
    },
    tableWidthAll() {
      return this.tableWidth + store.getters.MenuWidth
    },
    queryLimit() {
      let limit = {
        table: "",
        sort: "",
        order: "asc",
        offset: 0,
        limit: this.components.tablePagesize
      }
      return limit
    }
  },
  mounted() {
    
    var that=this;    
    window.addEventListener("resize", function(){
      const ob = that.$refs[that.components.tableId].$el.getBoundingClientRect()
      that.tableWidth = window.innerWidth-ob.left -40
      that.tableHeight = window.innerHeight-ob.top-35
    })
    setTimeout(() => {
      const ob = that.$refs[that.components.tableId].$el.getBoundingClientRect()
      that.tableWidth = window.innerWidth-ob.left -40
      that.tableHeight = window.innerHeight-ob.top-35
    },200)
    
  },
  props: {
    value: {},
    components: {},
    size: {
      type: String,
      default: 'mini'
    },
    // 是否启用多选
    selection: {
      type: Boolean,
      default: true
    },
    // 是否显示行号
    index: {
      type: Boolean,
      default: true
    },  
    // 数据对象
    tableItemData: {},
    // 是否显示汇总行
    showSummary: {
      type: Boolean,
      default: true
    },
    // 会总行数据，只有启用后台汇总的时候才使用
    summaryData: {},
    // 当前的查询条件信息
    queryParam: {},
    //是否只读，针对可以编辑单元格
    readOnly: {
      type: Boolean,
      default: true
    },
    //明细表主键id
    itemPrimaryId: {}
    
  },
  methods: {
    // 表格设置中的选择默认记录数事件
    settingPageSizeChange(e) {
      this.components.tablePagesize = e
      this.$emit('sort-change', this.queryLimit, 'None')
    },
    // 表格排序事件
    sortChange(column, prop, order ) {
      this.datas.forEach((item,index)=> {
            this.$set(this.components, item.controlId, item)
            if(item.controlGroup == 'Search' || item.controlGroup == 'SearchMore'){
              this.$set(this.queryParam.queryData, item.controlId, item)
            }
          })
    },
    //单元格点击事件(主键)
    cellClick(row, column, cell, event) {
      this.nowRows = row.index
      if(this.columnDataProp[column.property] !== undefined && this.columnDataProp[column.property].columnPrimary){
        var primaryId = row[column.property]
        this.$emit('cell-itemclick', this.components.tableId, primaryId)
      }
    },
    //表格选中事件
    selectionChange(selection, row){
      this.$emit('selection-change', selection)
    },
    // 单元格样式针对主键设置
    cellClass({row, column, rowIndex, columnIndex}) {
      let classValue = ''
      // 判断是否存在主键列
      if(this.columnDataProp[column.property] !== undefined && this.columnDataProp[column.property].columnPrimary){
        classValue = classValue + ' cellPrimaryClass'
      }
      // 判断是否有删除标志，并且是否为已删除状态
      if(column.delType !== undefined && column.delType){
        classValue = classValue + ' cellDelClass'
      }
      //无效、报警、未完成等样式
      if(this.columnDataProp[column.property] !== undefined && this.columnDataProp[column.property].columnDatasource == "existsType"){
        if(row[column.property]=="0"){
          classValue = classValue + ' cellNoExists'
        }        
      }
      
      return classValue
    },
    // 行记录样式针对单据不同状态颜色不同
    rowClass({row, rowIndex}) {
      row.index = rowIndex
      if(row.realIndex === undefined ){
        row.realIndex = rowIndex
      }      
      if(row.verifyType !== undefined && row.verifyType){
        return 'rowVerifyClass'
      }
      return ''
    },
    // 拖拽移动顺序相关
    handleDragStart(e,item){
        this.dragging = item;
    },
    handleDragEnd(e,item){
        this.dragging = null
    },
    //首先把div变成可以放置的元素，即重写dragenter/dragover
    handleDragOver(e) {
        e.dataTransfer.dropEffect = 'move'// e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
    },
    handleDragEnter(e,item){
        e.dataTransfer.effectAllowed = "move"//为需要移动的元素设置dragstart事件
        if(item === this.dragging){
            return
        }       
        const newItems = [...this.components.tableColumns]
        const src = newItems.indexOf(this.dragging)
        const dst = newItems.indexOf(item) 
        newItems.splice(dst, 0, ...newItems.splice(src, 1)) 
        this.components.tableColumns = newItems 
        
    },
    // 改变列宽事件，自动更新列宽属性
    headerDragend(newWidth, oldWidth, column, event){
      const columnName = column.property
      for(var key in this.components.tableColumns){
        if(this.components.tableColumns[key].columnName == columnName){
          this.components.tableColumns[key].columnWidth = newWidth
          break
        }
      }
    },
    // 恢复默认值
    rollBackTableSetting() {
      this.queryLoding = true
      rollBackTableSetting(this.components.tableId).then(res => {
        const code = res.status.code    
        if(code == 200){
          const table = res.data.table
          this.components.tableColumns = table[0].tableColumns
          this.components.tablePagesize = table[0].tablePagesize
          this.components.tableSorttype = table[0].tableSorttype
          this.components.tableSumtype = table[0].tableSumtype
          Notification.success({
            title: '成功恢复默认值',
            duration: 1500
          })
        }
        this.queryLoding = false
      })
      .catch(error => {
        this.queryLoding = false
        return Promise.reject('error')
      })
    },
    // 保存表格参数配个
    saveTableSetting() {
      this.saveLoding = true
      saveTableSetting(this.components).then(res => {
        const code = res.status.code    
        if(code == 200){
          Notification.success({
            title: '参数保存成功',
            duration: 1500
          })
        }        
        this.saveLoding = false
      })
      .catch(error => {
        this.saveLoding = false
        return Promise.reject('error')
      })
    },
    // 导出表格
    exportExcel(exportType){

      if(this.tableItemData.length>0){
        queryItemExport(this.queryParam, this.itemPrimaryId, this.components.tableId).then(res => {
          const content = res.data
          const blob = new Blob([content])//构造一个blob对象来处理数据
          const fileName = decodeURI(res.headers.filename) + '.xlsx'
          //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
          //IE10以上支持blob但是依然不支持download
          if ('download' in document.createElement('a')) { //支持a标签download的浏览器
            const link = document.createElement('a')//创建a标签
            link.download = fileName//a标签添加属性
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            document.body.appendChild(link)
            link.click()//执行下载
            URL.revokeObjectURL(link.href) //释放url
            document.body.removeChild(link)//释放标签
          } else { //其他浏览器
            navigator.msSaveBlob(blob, fileName)
          }      
        })
        .catch(error => {
          return Promise.reject('error')
        }) 
      }else{
        Notification.warning({
          title: '请先查询数据',
          duration: 1500
        })
      }           
    }
  }
}
</script>
<style scoped lang="scss">  
  .jr-bigtable-badge{
    position:absolute;
    right: 10px;
    top: -35px; 
  }
  .jr-bigtable-setting-move:hover{
    cursor: s-resize;
  }
  .jr-bigtable-column-item{
    transition: all linear .3s; 
    width: 90%; 
    display: flex; 
    flex-direction: row ; 
    justify-content: space-between; 
    align-items: center;
  }

</style>


// WEBPACK FOOTER //
// src/components/componentsjr/JrBigitemtable.vue